// import { ENVIRONMENT } from "./facturafacil";

export const limpiarObjeto = (obj) => {
  if (Array.isArray(obj)) {
    return obj
      .map(limpiarObjeto) // limpiar cada elemento del array
      .filter((v) => v != null); // eliminar null o undefined
  } else if (obj && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj)
        .map(([k, v]) => [k, limpiarObjeto(v)]) // limpiar recursivamente
        .filter(([, v]) => v != null), // eliminar propiedades nulas
    );
  } else {
    return obj; // si es valor primitivo, se devuelve tal cual
  }
};

export const getTiposPersonas = () => [
  { id: '01', text:'Contribuyente'},
  { id: '02', text:'Consumidor final'},
  { id: '03', text:'Gobierno'},
  { id: '04', text:'Extranjero'},
]

export const getTipoPagos = () => [
  { id: '01', text: 'Crédito' },
  { id: '02', text: 'Efectivo' },
  { id: '03', text: 'Tarjeta de crédito' },
  { id: '04', text: 'Tarjeta de débito' },
  { id: '05', text: 'Tarjeta de fidelidad' },
  { id: '06', text: 'Vale' },
  { id: '07', text: 'Tarjeta de regalo' },
  { id: '08', text: 'Transferencia o déposito bancario' },
  { id: '09', text: 'Cheque' },
  { id: '10', text: 'Punto de venta' },
  { id: '99', text: 'Otro' },
];

// ##########################################################
// ##########################################################
// ##########################################################
// ##########################################################
// ##########################################################

export const getdata = (recibo, suc, progra) => {
  // window.console.log('succc', suc, recibo,'>',progra);
  let apidev = process.env.VUE_APP_GRAPHQL;
  let ENVIRONMENT = 2 // 2: pruebas, 1: produccion
  if( apidev.includes("apidev") ){
    ENVIRONMENT = 2
  }else{
    ENVIRONMENT = 1
  }

  const partes = recibo.fecha_registro.split(" ");
  let fecha_emision = partes[0]

  const items = [];
  let total = 0;
  recibo.detalle.forEach((d, i) => {
    total += d.monto;
    const item = {
      line: i + 1,
      price: '' + d.monto,
      quantity: '1',
      internal_code: d.concepto_pago_id,
      description: progra.nombre_compuesto,
      taxes: [
        {
          type: '01',
          code: '00',
          amount: '0',
        },
      ],
      discount: '0',
      additional_info: ''+d.concepto,
    };
    items.push(item);
  });

  return {
    header: {
      id: recibo.id,
      environment: ENVIRONMENT,
      /* branch: {
        code: '0001',
        coordinates: '8.983956,-79.530231',
        address: 'XFM9+HXV, Av. Manuel Espinosa Batista, Panamá, Provincia de Panamá, Panamá',
        phone: '2144676',
        location: 'XFM9+HXV',
      }, */
      issue_date: fecha_emision + 'T00:00:00-05:00',
      // pos: '001', // no informamos
    },
    document: {
      fd_number: 0,
      type: 'FAC',
      sale_type: '1',
      // info: 'probando la api',
      receptor: {
        type: '',
        name: '',
        ruc: '6-720-659',
        dv: 87,
        location: '',
        ruc_type: '1',
        address: '',
        email: '',
      },
      items: items,
      payments: [
        {
          type: '08',
          amount: total,
          description: 'Descripción del pago',
        },
      ],
      xtotal: '2',
      // dest_country: 'PA',
      payment_term: 1,
      trim_amounts: true,
      // issue_type: '01',
      order_info: {
        // max 12 caracteres
        // 123456789012
        // rec:519338-sede:82
        // 519338-s82
        number: `${recibo.id}-s${recibo.sede_id}`,
        // max 4000
        info: `nro: ${recibo.numero_recibo}, ${progra.nombre_compuesto}`,
      },
    },
  };
};
